import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { removeLoadingKey } from '../helpers/common'

export const COGSLoadingKeys = {
    getCOGSPreview: "GET_COGS_PREVIEW",
}

const initialState = {
    loading: false,
    loadingKeys: [],
    firstLoadComplete: false,
    error: null,
    cogsPreview: {
        items: [],
        total: 0,
        statesControl: 0,
        summary: {
            skuCount: 0,
            canonicalCoverageCount: 0,
            missingFreightCount: 0,
            missingBomCount: 0,
            weightedCoverageCount: 0,
            exceptionCount: 0,
            supplierCount: 0,
        },
        suppliers: [],
    },
    pagination: {
        isTheLastPage: false,
        rangeRows: '',
        totalPages: 0,
    },
}

export const getCOGSPreviewRequest = createAsyncThunk(
    'cogsPreview/getCOGSPreviewRequest',
    async ({
        searchTerm,
        selectedCategoryId,
        selectedSubcategoryId,
        selectedStatusId,
        selectedSupplierId,
        selectedControlState,
        selectedCostBasisState,
        page,
        itemsPerPage,
    }, { rejectWithValue }) => {
        try {
            const { data } = await axios.get('/api/v1/get-cogs-preview', {
                params: {
                    searchTerm,
                    selectedCategoryId,
                    selectedSubcategoryId,
                    selectedStatusId,
                    selectedSupplierId,
                    selectedControlState,
                    selectedCostBasisState,
                    page,
                    itemsPerPage,
                }
            });
            return data;
        } catch (error) {
            if ('string' === typeof error.response.data) {
                return rejectWithValue(error.response.data)
            } else {
                return rejectWithValue(error.response.data.errors || error.response.data.error)
            }
        }
    }
)

export const cogsPreviewSlice = createSlice({
    name: 'cogsPreview',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCOGSPreviewRequest.pending, (state) => {
                state.loading = true;
                state.loadingKeys = [...state.loadingKeys, COGSLoadingKeys.getCOGSPreview];
            })
            .addCase(getCOGSPreviewRequest.fulfilled, (state, action) => {
                state.loading = false;
                state.cogsPreview = {
                    items: action.payload?.items || [],
                    total: action.payload?.total || 0,
                    statesControl: action.payload?.statesControl || 0,
                    summary: action.payload?.summary || {
                        skuCount: 0,
                        canonicalCoverageCount: 0,
                        missingFreightCount: 0,
                        missingBomCount: 0,
                        weightedCoverageCount: 0,
                        exceptionCount: 0,
                        supplierCount: 0,
                    },
                    suppliers: action.payload?.suppliers || [],
                };
                state.pagination.isTheLastPage = action.payload?.isTheLastPage ?? false;
                state.pagination.rangeRows = action.payload?.rangeRows ?? '';
                state.pagination.totalPages = action.payload?.totalPages ?? 0;
                state.error = null;
                state.firstLoadComplete = true;
                state.loadingKeys = removeLoadingKey(COGSLoadingKeys.getCOGSPreview, state.loadingKeys);
            })
            .addCase(getCOGSPreviewRequest.rejected, (state, action) => {
                state.loading = false;
                state.cogsPreview = {
                    items: [],
                    total: 0,
                    statesControl: 0,
                    summary: {
                        skuCount: 0,
                        canonicalCoverageCount: 0,
                        missingFreightCount: 0,
                        missingBomCount: 0,
                        weightedCoverageCount: 0,
                        exceptionCount: 0,
                        supplierCount: 0,
                    },
                    suppliers: [],
                };
                state.pagination.isTheLastPage = false;
                state.pagination.rangeRows = '';
                state.pagination.totalPages = 0;
                state.error = action.error?.message;
                state.firstLoadComplete = true;
                state.loadingKeys = removeLoadingKey(COGSLoadingKeys.getCOGSPreview, state.loadingKeys);
            })
    }
})
export const { } = cogsPreviewSlice.actions;
export default cogsPreviewSlice.reducer 